import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, CheckIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ColorComparisonPage() {
  return <div className="w-full bg-[#f8f8f8]" data-id="element-821">
      {/* Back button */}
      <div className="max-w-7xl mx-auto px-6 py-8" data-id="element-822">
        <Link to="/" className="flex items-center text-gray-600 hover:text-[#214ae9] transition-colors font-medium" data-id="element-823">
          <ArrowLeftIcon size={20} className="mr-2" data-id="element-824" />
          <span data-id="element-825">Go Back</span>
        </Link>
      </div>

      <div className="max-w-7xl mx-auto px-6 pb-16" data-id="element-826">
        <div className="text-center mb-12" data-id="element-827">
          <h1 className="text-4xl md:text-5xl font-bold text-[#111111] mb-4" data-id="element-828">
            Color Strategy Options
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-829">
            Explore different approaches to using your brand colors. Each option
            shows a unique hierarchy and emphasis.
          </p>
        </div>

        <div className="space-y-16" data-id="element-830">
          {/* Option 1: Blue Primary (Current) */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-831">
            <div className="bg-[#1a0647] px-8 py-4 border-b border-gray-700" data-id="element-832">
              <h2 className="text-xl font-bold text-white" data-id="element-833">
                Option 1: Blue Primary
              </h2>
              <p className="text-sm text-gray-300" data-id="element-834">
                Professional and trustworthy • Current implementation
              </p>
            </div>
            <div className="p-8" data-id="element-835">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-836">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-837">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-838">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-839">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-840">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-841">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-lg flex items-center space-x-2" data-id="element-842">
                      <span data-id="element-843">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-844" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-845">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-846">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-847">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-848">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-849" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-850">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-851">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-852">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-853">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-854" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-855">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-856">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 2: Purple Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-857">
            <div className="bg-[#b063ff] px-8 py-4 border-b border-purple-400" data-id="element-858">
              <h2 className="text-xl font-bold text-white" data-id="element-859">
                Option 2: Purple Primary
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-860">
                Modern and energetic • Bold personality
              </p>
            </div>
            <div className="p-8" data-id="element-861">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-862">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-863">
                  <div className="inline-block bg-[#00f4f8] bg-opacity-20 text-[#00f4f8] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#00f4f8] border-opacity-30" data-id="element-864">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-865">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-866">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-867">
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg flex items-center space-x-2" data-id="element-868">
                      <span data-id="element-869">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-870" />
                    </button>
                    <button className="border-2 border-[#214ae9] text-[#214ae9] px-6 py-3 rounded-lg font-bold hover:bg-[#214ae9] hover:text-white transition-all" data-id="element-871">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-872">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-873">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-874">
                      <ShieldIcon className="w-6 h-6 text-[#b063ff]" data-id="element-875" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-876">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-877">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-878">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-879">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-880" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-881">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-882">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 3: Cyan Primary */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-883">
            <div className="bg-[#00f4f8] px-8 py-4 border-b border-cyan-300" data-id="element-884">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-885">
                Option 3: Cyan Primary
              </h2>
              <p className="text-sm text-[#111111] text-opacity-70" data-id="element-886">
                Fresh and innovative • High energy
              </p>
            </div>
            <div className="p-8" data-id="element-887">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-888">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-889">
                  <div className="inline-block bg-[#b063ff] bg-opacity-20 text-[#b063ff] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#b063ff] border-opacity-30" data-id="element-890">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-891">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-892">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-893">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-[#00d9dd] transition-all shadow-lg flex items-center space-x-2" data-id="element-894">
                      <span data-id="element-895">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-896" />
                    </button>
                    <button className="border-2 border-[#b063ff] text-[#b063ff] px-6 py-3 rounded-lg font-bold hover:bg-[#b063ff] hover:text-white transition-all" data-id="element-897">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-898">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-899">
                    <div className="w-12 h-12 bg-[#00f4f8] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-900">
                      <ShieldIcon className="w-6 h-6 text-[#00f4f8]" data-id="element-901" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-902">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-903">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border border-gray-200" data-id="element-904">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-10 rounded-xl flex items-center justify-center mb-4" data-id="element-905">
                      <CheckIcon className="w-6 h-6 text-[#214ae9]" data-id="element-906" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-907">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-908">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 4: Balanced Trio */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-909">
            <div className="bg-gradient-to-r from-[#214ae9] via-[#b063ff] to-[#00f4f8] px-8 py-4" data-id="element-910">
              <h2 className="text-xl font-bold text-white" data-id="element-911">
                Option 4: Balanced Trio
              </h2>
              <p className="text-sm text-white text-opacity-90" data-id="element-912">
                Equal emphasis • Vibrant and dynamic
              </p>
            </div>
            <div className="p-8" data-id="element-913">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-914">
                {/* Hero preview */}
                <div className="bg-[#1a0647] rounded-xl p-8" data-id="element-915">
                  <div className="inline-block bg-white bg-opacity-10 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-white border-opacity-20" data-id="element-916">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-917">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-918">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-919">
                    <button className="bg-gradient-to-r from-[#214ae9] to-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:shadow-xl transition-all shadow-lg flex items-center space-x-2" data-id="element-920">
                      <span data-id="element-921">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-922" />
                    </button>
                    <button className="border-2 border-[#00f4f8] text-[#00f4f8] px-6 py-3 rounded-lg font-bold hover:bg-[#00f4f8] hover:text-[#1a0647] transition-all" data-id="element-923">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-924">
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-925">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-926">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-927" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-928">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-929">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#f8f8f8] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-930">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-931">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-932" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-933">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-934">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 5: High Contrast */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-935">
            <div className="bg-[#111111] px-8 py-4 border-b border-gray-800" data-id="element-936">
              <h2 className="text-xl font-bold text-white" data-id="element-937">
                Option 5: High Contrast
              </h2>
              <p className="text-sm text-gray-400" data-id="element-938">
                Bold and striking • Maximum impact
              </p>
            </div>
            <div className="p-8" data-id="element-939">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-940">
                {/* Hero preview */}
                <div className="bg-[#111111] rounded-xl p-8 border-2 border-[#00f4f8]" data-id="element-941">
                  <div className="inline-block bg-[#00f4f8] text-[#111111] px-4 py-1.5 rounded-full text-sm font-bold mb-6" data-id="element-942">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-white mb-4" data-id="element-943">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-300 mb-6" data-id="element-944">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-945">
                    <button className="bg-[#00f4f8] text-[#111111] px-6 py-3 rounded-lg font-bold hover:bg-white transition-all shadow-lg flex items-center space-x-2" data-id="element-946">
                      <span data-id="element-947">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-948" />
                    </button>
                    <button className="bg-[#b063ff] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#9b4ee6] transition-all shadow-lg" data-id="element-949">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-950">
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#214ae9]" data-id="element-951">
                    <div className="w-12 h-12 bg-[#214ae9] rounded-xl flex items-center justify-center mb-4" data-id="element-952">
                      <ShieldIcon className="w-6 h-6 text-white" data-id="element-953" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-954">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-955">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-[#111111] rounded-xl p-6 border-2 border-[#b063ff]" data-id="element-956">
                    <div className="w-12 h-12 bg-[#b063ff] rounded-xl flex items-center justify-center mb-4" data-id="element-957">
                      <CheckIcon className="w-6 h-6 text-white" data-id="element-958" />
                    </div>
                    <h4 className="text-lg font-bold text-white mb-2" data-id="element-959">
                      Easy to Use
                    </h4>
                    <p className="text-gray-400 text-sm" data-id="element-960">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Option 6: Light & Airy */}
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-200" data-id="element-961">
            <div className="bg-white px-8 py-4 border-b-2 border-[#214ae9]" data-id="element-962">
              <h2 className="text-xl font-bold text-[#111111]" data-id="element-963">
                Option 6: Light & Airy
              </h2>
              <p className="text-sm text-gray-600" data-id="element-964">
                Minimal and clean • Approachable
              </p>
            </div>
            <div className="p-8" data-id="element-965">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-966">
                {/* Hero preview */}
                <div className="bg-white rounded-xl p-8 border-2 border-gray-200" data-id="element-967">
                  <div className="inline-block bg-[#214ae9] bg-opacity-5 text-[#214ae9] px-4 py-1.5 rounded-full text-sm font-semibold mb-6 border border-[#214ae9] border-opacity-20" data-id="element-968">
                    🚀 New Feature
                  </div>
                  <h3 className="text-3xl font-bold text-[#111111] mb-4" data-id="element-969">
                    Protect your family from digital chaos
                  </h3>
                  <p className="text-gray-600 mb-6" data-id="element-970">
                    Take control of your family's digital security with our
                    comprehensive protection tools.
                  </p>
                  <div className="flex flex-wrap gap-3" data-id="element-971">
                    <button className="bg-[#214ae9] text-white px-6 py-3 rounded-lg font-bold hover:bg-[#1a3bb8] transition-all shadow-md flex items-center space-x-2" data-id="element-972">
                      <span data-id="element-973">Get Started</span>
                      <ArrowRightIcon size={18} data-id="element-974" />
                    </button>
                    <button className="bg-white border-2 border-gray-300 text-[#111111] px-6 py-3 rounded-lg font-bold hover:border-[#214ae9] hover:text-[#214ae9] transition-all" data-id="element-975">
                      Learn More
                    </button>
                  </div>
                </div>
                {/* Feature cards */}
                <div className="space-y-4" data-id="element-976">
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#214ae9] transition-colors" data-id="element-977">
                    <div className="w-12 h-12 bg-[#214ae9] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-978">
                      <ShieldIcon className="w-6 h-6 text-[#214ae9]" data-id="element-979" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-980">
                      Comprehensive Protection
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-981">
                      All the tools you need in one place
                    </p>
                  </div>
                  <div className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-[#b063ff] transition-colors" data-id="element-982">
                    <div className="w-12 h-12 bg-[#b063ff] bg-opacity-5 rounded-xl flex items-center justify-center mb-4" data-id="element-983">
                      <CheckIcon className="w-6 h-6 text-[#b063ff]" data-id="element-984" />
                    </div>
                    <h4 className="text-lg font-bold text-[#111111] mb-2" data-id="element-985">
                      Easy to Use
                    </h4>
                    <p className="text-gray-600 text-sm" data-id="element-986">
                      Simple setup in minutes
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}